import LplLogoWhiteIcon from '../assests/images/icons/lpl-logo-white-bg.png'
import Dashboard from '../assests/images/icons/home-icon-side.png'
import AddIconFilters from '../assests/svg/add-icon-filters.svg'
import LocalityIcon from '../assests/svg/LocalityIcon.png'
import CitySideIcon from '../assests/svg/city-side-icon.png'
import StateSideIcon from '../assests/svg/setting-side-icon.svg'
import SelectCountry from '../assests/svg/select-country.png'
import MasterIcon from '../assests/svg/mastersKey.png'
import SubscriptionIcon from '../assests/svg/subscription-icon.png'
import UserMangIcon from '../assests/svg/user-manage-icon.png'
import RolesIcon from '../assests/svg/roles=icon.svg'
import BMBLogo from '../assests/images/icons/Book-my-beauty-logo.png'
import BMBSimpleLogo from '../assests/images/icons/Book my beauty logo.png'
import HomeIcon from '../assests/images/icons/HomeIcon.png'
import SettingIcon from '../assests/images/icons/SettingIcon.png'
import Customers from '../assests/images/icons/UsersManage.png'
import CategoriesIcon from '../assests/images/icons/CategoriesIcon.png'
import SalonIcon from '../assests/images/icons/SalonIcon.png'
import UserManagementIcon from '../assests/images/icons/UserManage.png'
import UserIcon from '../assests/images/icons/UserIcon.png'
import EditIcon from '../assests/images/icons/EditIcon.png'
import DeleteIcon from '../assests/images/icons/DeleteIcon.png'
import ViewIcon from '../assests/images/icons/ViewIcon.png'
import AdminIcon from '../assests/images/icons/AdminIcon.png'
import AppoinmentIcon from '../assests/images/icons/AppoinmentIcon.png'
import BMBLogoSmall from '../assests/images/icons/BMB Logo SM.png'
import LoginImage from '../assests/images/icons/LoginPageImage.png'
import BlockIcon from  '../assests/images/icons/block.png'
import BanIcon from  '../assests/images/icons/ban.png'
import Male from '../assests/svg/male.png'
import Female from  '../assests/svg/female.png'
import PhoneIcon from '../assests/images/icons/phone-icon.png'
import LocationIcon from '../assests/images/icons/location-icon.png'
import UserProfile from '../assests/images/icons/user-icon.png'
import Coupons from '../assests/images/icons/coupons.png'
import GenderIcon from '../assests/images/icons/gender-icon.png'
import TestimonialIcon from '../assests/images/icons/testimonial-icon.svg'
import ImageIcon from '../assests/images/icons/image-icon.svg'
import Makeup from '../assests/images/thumbnails/makeup.webp';
import Hair from '../assests/images/thumbnails/hair.webp';
import SkinCare from '../assests/images/thumbnails/skincare.webp';
import VideoIcon from '../assests/images/icons/videoIcon.png';
import imageNotFound from '../assests/images/icons/34-img-not-found.jpg'
import notification from '../assests/svg/notification.svg'
import customeService from '../assests/svg/custome-service.png'
import AppVersionIcon from '../assests/images/icons/app-version.svg'


const IMAGES = {
  LoginImage,
  BMBSimpleLogo,
  BMBLogoSmall,
  AppoinmentIcon,
  UserManagementIcon,
  UserIcon,
  AdminIcon,
  DeleteIcon,
  SettingIcon,
  ViewIcon,
  SalonIcon,
  Customers,
  CategoriesIcon,
  HomeIcon,
  BMBLogo,
  LplLogoWhiteIcon,
  Dashboard,
  EditIcon,
  AddIconFilters,
  LocalityIcon,
  CitySideIcon,
  StateSideIcon,
  SelectCountry,
  MasterIcon,
  SubscriptionIcon,
  UserMangIcon,
  customeService,
  RolesIcon,
  BlockIcon,
  BanIcon,
  Male,
  Female,
  LocationIcon,
  PhoneIcon,
  Coupons,
  UserProfile,
  GenderIcon,
  TestimonialIcon,
  ImageIcon,
  Makeup,
  Hair,
  SkinCare,
  VideoIcon,
  imageNotFound,
  notification,
  AppVersionIcon,
}

export default IMAGES;